import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesInternalBank } from "../../constants";
import {
  GetExpensesStatisticsBody,
  GetExpensesStatisticsResponse
} from "./getExpensesStatistics.types";

export const requestGetExpensesStatistics = async (
  params: GetExpensesStatisticsBody
): Promise<GetExpensesStatisticsResponse> => {
  return await instance.get(
    buildUrl(
      ApiRoutesInternalBank.Expenses,
      ApiRoutesInternalBank.ExpensesStatistics
    ),
    {
      params
    }
  );
};
